import {TemplateVersion, ToServerTemplateVersion} from 'notebook/entry-templates/TemplateConstants';
import notifications from 'notifications';
import {getStore} from 'redux-stores/Store';
import * as LoadingScreen from 'ui-library/LoadingScreen';
import * as StageEntryTemplateDAO from 'workflows/dao/StageEntryTemplateDAO';
import {StageConfiguration, WorkflowStage} from 'workflows/WorkflowConstants';

export function fetch(
  stageConfigurationId: string,
  {
    onSuccess,
    onFailure,
  }: {
    onSuccess: (
      args: StageConfiguration & {latestVersionId: number; templateVersion: TemplateVersion}
    ) => void;
    onFailure: (error: Response) => void;
  }
): void {
  StageEntryTemplateDAO.fetch(stageConfigurationId)
    .done(
      ({
        stageConfiguration,
        latestVersionId,
        templateVersion,
      }: StageEntryTemplateDAO.FetchStageEntryTemplateResponse) => {
        onSuccess({...stageConfiguration, latestVersionId, templateVersion});
      }
    )
    .fail((error) => {
      notifications.notifyError(error);
      onFailure(error);
    });
}

export function save(
  stageConfigurationId: string,
  serverEntryTemplate: {
    entryTemplateName: string;
    templateVersion: ToServerTemplateVersion;
    metadata: {
      clientId: string;
      latestVersionId: number;
      action: string;
    };
  },
  {
    onSuccess,
    onFailure,
  }: {
    onSuccess: (cidIdMap: {[cid: string]: string}) => void;
    onFailure: (error: Response) => void;
  }
): void {
  LoadingScreen.show('Saving');
  StageEntryTemplateDAO.save(stageConfigurationId, serverEntryTemplate)
    .done(
      ({
        cidIdMap,
        workflowStage,
        stageConfiguration,
      }: StageEntryTemplateDAO.SaveStageEntryTemplateResponse) => {
        onSuccess(cidIdMap);
        if (workflowStage) {
          getStore().dispatch({
            type: StageEntryTemplateActionType.WORKFLOW_STAGE_FETCH_COMPLETED,
            workflowStage,
          });
        }
        if (stageConfiguration) {
          getStore().dispatch({
            type: StageEntryTemplateActionType.WORKFLOW_STAGE_CONFIGURATION_FETCH_COMPLETED,
            stageConfiguration,
          });
        }
      }
    )
    .fail((error) => {
      notifications.notifyError(error);
      onFailure(error);
    })
    .always(() => {
      LoadingScreen.hide();
    });
}

export enum StageEntryTemplateActionType {
  WORKFLOW_STAGE_FETCH_COMPLETED = 'WORKFLOW_STAGE_FETCH_COMPLETED',
  WORKFLOW_STAGE_CONFIGURATION_FETCH_COMPLETED = 'WORKFLOW_STAGE_CONFIGURATION_FETCH_COMPLETED',
}

interface WorkflowStageFetchCompletedAction {
  type: StageEntryTemplateActionType.WORKFLOW_STAGE_FETCH_COMPLETED;
  workflowStage: WorkflowStage;
}

interface WorkflowStageConfigurationFetchCompletedAction {
  type: StageEntryTemplateActionType.WORKFLOW_STAGE_CONFIGURATION_FETCH_COMPLETED;
  stageConfiguration: StageConfiguration;
}

export type StageEntryTemplateAction =
  | WorkflowStageFetchCompletedAction
  | WorkflowStageConfigurationFetchCompletedAction;
